import { render, staticRenderFns } from "./SupporterEditDetails.vue?vue&type=template&id=3606e8e6&"
import script from "./SupporterEditDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports